var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.8012,
    height: 37.8012,
    rx: 18.9006,
    fill: "#E86A0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.128 11.9347H12.2781C11.3866 11.9347 10.6799 12.6495 10.6799 13.5409L10.6719 23.1783C10.6719 24.0698 11.3866 24.7846 12.2781 24.7846H25.128C26.0194 24.7846 26.7342 24.0698 26.7342 23.1783V13.5409C26.7342 12.6495 26.0194 11.9347 25.128 11.9347ZM25.128 23.1783H12.2781V18.3596H25.128V23.1783ZM25.128 15.1472H12.2781V13.5409H25.128V15.1472Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.9d8313ca721f6a0aba815147660c331c.svg";
export { ForwardRef as ReactComponent };